var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "url(#paint0_linear_1_429)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5763 10.7793H21.356V21.491H10.5763V10.7793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 20.8V14.096H13.248V20.8H11.2ZM13.312 12.24C13.328 12.816 12.896 13.28 12.208 13.28C11.568 13.28 11.152 12.816 11.152 12.24C11.152 11.648 11.584 11.2 12.24 11.2C12.896 11.2 13.312 11.648 13.312 12.24ZM18.688 20.8V17.088C18.688 16.224 18.4 15.632 17.648 15.632C17.088 15.632 16.752 16.032 16.592 16.416C16.544 16.56 16.528 16.752 16.528 16.944V20.8H14.48V16.24C14.48 15.408 14.448 14.704 14.432 14.096H16.208L16.304 15.04H16.336C16.608 14.592 17.28 13.952 18.384 13.952C19.728 13.952 20.752 14.864 20.752 16.848V20.8H18.688ZM24 9.408C24 8.64 23.36 8 22.592 8H9.408C8.64 8 8 8.64 8 9.408V22.592C8 23.36 8.64 24 9.408 24H22.592C23.36 24 24 23.36 24 22.592V9.408Z",
    fill: "url(#paint1_linear_1_429)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_429",
    x1: 0,
    y1: 16,
    x2: 32,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_429",
    x1: 8,
    y1: 16,
    x2: 24,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIn);
export default __webpack_public_path__ + "static/media/icon-in.5acbf0ec623c4c9b71a014502157f2e2.svg";
export { ForwardRef as ReactComponent };